import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`suppliers`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`suppliers`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`suppliers`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`suppliers/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`suppliers/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`suppliers/password`, data);
  return response;
};
